/**
 * demo-store — customization PDP (template product.customization).
 *
 * Add to cart posts the product with its customization properties (the
 * theme's individualized_title input and the hidden properties[...] inputs
 * Uploadery attaches after a logo upload — both are form-associated via the
 * form attribute, so FormData(form) picks them up), then sends the shopper
 * to the customization cart instead of opening the drawer. Runs in the
 * capture phase so it wins over Horizon's product-form-component handler.
 */
(function () {
  var TARGET = document.currentScript && document.currentScript.dataset.redirect
    ? document.currentScript.dataset.redirect
    : '/pages/send-to-many-customizer';

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!(form instanceof HTMLFormElement)) return;
      if (!/\/cart\/add/.test(form.getAttribute('action') || '')) return;
      if (!form.closest('product-form-component')) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      var button = form.querySelector('button[type="submit"]');
      if (button) button.disabled = true;

      var data = new FormData(form);
      data.delete('section-id');
      data.delete('sections');
      // don't send blank customization values as properties
      Array.from(data.keys()).forEach(function (key) {
        if (/^properties\[/.test(key) && !String(data.get(key) || '').trim()) data.delete(key);
      });

      fetch('/cart/add.js', {
        method: 'POST',
        body: data,
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      })
        .then(function (r) { return r.json(); })
        .then(function (json) {
          if (json && json.status) {
            if (button) button.disabled = false;
            window.alert(json.description || json.message || 'Could not add to cart.');
            return;
          }
          window.location.href = TARGET;
        })
        .catch(function () {
          if (button) button.disabled = false;
          form.submit();
        });
    },
    true
  );
})();
